<section class="podcast-icon">
  <a (click)="togglePodcastDropdown()"
     noDblClick
     title="Listen to podcast"
     *ngIf="showPodcastIcon"
     class="podcast-icon__icon">
    <fa-icon [icon]="['fas', 'podcast']"></fa-icon>
  </a>
  <div
    [ngClass]="{
      'podcast-icon__dropdown--show': showPodcastDropdown,
      'podcast-icon__dropdown--loader': loadingData && !podcastUrl,
      'podcast-icon__dropdown--error': this.errorMessage
      }"
    class="podcast-icon__dropdown">
    <fa-icon
      *ngIf="loadingData && !podcastUrl"
      class="podcast-icon__dropdown__preloader" [icon]="['fas', 'sync']" [spin]="true"></fa-icon>
    <div
      *ngIf="this.errorMessage"
      class="podcast-icon__dropdown__error-message">{{this.errorMessage}}</div>
    <div
      *ngIf="podcastUrl"
      ngxClipboard
      [cbContent]="podcastUrl"
      (cbOnSuccess)="linkCopied = true"
      [ngClass]="{'podcast-icon__dropdown__url-holder--copied': linkCopied}"
      class="podcast-icon__dropdown__url-holder">{{podcastUrl}}</div>
    <h2 *ngIf="podcastUrl">Instructions</h2>
    <ul
      *ngIf="podcastUrl"
      class="podcast-icon__dropdown__instructions-list">
      <li>Launch podcasts app</li>
      <li>Go to Library</li>
      <li>Select "Add a podcast by URL"</li>
    </ul>
    <span *ngIf="podcastUrl"
          class="podcast-icon__dropdown__help-info">
      For more info how to add podcast <a [routerLink]="['/how-to-use-podcast']" title="Get more info about adding the podcast">click here</a>.
    </span>
    <a
      *ngIf="podcastUrl || (!podcastUrl && this.errorMessage)"
      (click)="closePodcastPopup()"
      class="podcast-icon__dropdown__close-popup-link">Close podcast popup</a>
  </div>
</section>
